import { useState } from 'react';
import { useTemplate } from '../../../../../../features/template/TemplateProvider';
import { OptionButton } from '../../../../../../utils/Button';
import InstOption from '../../../../../../utils/InstOption';
import cn from '../../../../../../utils/cn';
import { ApiDeleteServicePackagePricing } from '../../../../Services/ServiceOperation';

function TableHeader() {
    return (
        <thead>
            <tr>
                <th scope="col">
                    <span>ID</span>
                </th>
                <th scope="col">
                    <span>Service Name</span>
                </th>
                <th scope="col">
                    <span>Pkg. Name</span>
                </th>
                <th scope="col" className="!w-24 text-center">
                    <span>Currency</span>
                </th>
                <th scope="col" className="!w-24 text-center">
                    <span>Amount</span>
                </th>
                <th scope="col" className="!w-24 text-center">
                    <span>VAT %</span>
                </th>
                <th scope="col" className="!w-24 text-center">
                    <span>Status</span>
                </th>
                <th scope="col" className="!w-16">
                    <span>#</span>
                </th>
            </tr>
        </thead>
    );
}

function TableRow({ data, openModal, packageInfo, productInfo, handleReload }) {
    const { setConfirm, setMessage } = useTemplate();
    const [itemId, setItemId] = useState(0);
    const handleDelete = (e, item) => {
        e.stopPropagation();
        setConfirm({
            text: 'Are you sure you want to delete this pricing?',
            clickAction: () => {
                ApiDeleteServicePackagePricing(
                    item?.appServiceId,
                    item?.appServicePackageId,
                    item?.id
                )
                    .then(({ title }) => {
                        setMessage({ type: 'success', text: title });
                        setConfirm(null);
                        handleReload();
                    })
                    .catch((err) => {
                        setMessage({ type: 'error', text: err.toString() });
                    });
            }
        });
    };

    const isPackageOrProductInactive =
        packageInfo?.status === 'inactive' || productInfo?.status === 'inactive';

    if (data && data.length === 0) {
        return (
            <tr className="hover:!bg-inherit">
                <td colSpan={4} className="!text-left">
                    No Service Found!
                </td>
            </tr>
        );
    }
    return data?.map((item) => (
        <tr
            key={item?.id}
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.id}</span>
            </td>
            <td>
                <span>{item?.serviceTitle}</span>
            </td>
            <td>
                <span>{item?.servicePackageName}</span>
            </td>

            <td className="text-center">
                <span>{item?.currency}</span>
            </td>
            <td className="text-center">
                <span>{item?.amount === -102 ? 'Free' : item?.amount}</span>
            </td>
            <td className="text-center">
                <span>{item?.vatPercent}</span>
            </td>
            <td className="text-center">
                <span
                    className={cn('capitalize text-warning', {
                        'text-secondary': item.status === 'active'
                    })}
                >
                    {item?.status}
                </span>
            </td>
            <td>
                <div className="flex flex-row w-full justify-end relative">
                    <OptionButton
                        disabled={isPackageOrProductInactive}
                        onClick={() => setItemId(item?.id)}
                    />
                    <InstOption showMenu={itemId === item?.id} setShowMenu={setItemId}>
                        <button type="button" onClick={() => openModal('service-pricing', item)}>
                            Edit
                        </button>
                        <button type="button" onClick={(e) => handleDelete(e, item)}>
                            Delete
                        </button>
                    </InstOption>
                </div>
            </td>
        </tr>
    ));
}
function TableWeb({ packageInfo, productInfo, openModal, handleReload }) {
    return (
        <table className="bik-table !w-full mb-4" cellPadding={0} cellSpacing={0}>
            <TableHeader />
            <tbody className="">
                <TableRow
                    data={packageInfo?.addons || []}
                    openModal={openModal}
                    productInfo={productInfo}
                    packageInfo={packageInfo}
                    handleReload={handleReload}
                />
            </tbody>
        </table>
    );
}

export default TableWeb;
